// @flow

import { DraftLiveStateEnum } from "@modules/service/constants";
import type { ReferralState } from "./types";

export const initialState: ReferralState = {
  requestsInProgress: 0,
  schema: null,
  list: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  current: null,
  draft: null,
  assignments: [],
};

export default initialState;
